export default __webpack_public_path__ + "static/media/job statuses.313ff698.png";